import {Component, Input} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {MatFormFieldAppearance} from "@angular/material/form-field";
import {Store} from "@ngrx/store";
import {AppState} from "../../store/store";
import {selectDimensionComponentObjects, selectDimensionSourceGroups} from '../../store/selectors';
import {selectDataSetDimensionsGroupComponentObjects} from '../../store/dataSetDimensionsGroups/dataSetDimensionsGroups.selectors';
import {Observable} from 'rxjs';
import {DatasetDimensionsGroupComponentObjects} from '../../classes/dataset-dimensions-group-component-object';
import {DimensionComponentObjects} from '../../classes/dimension-component-object';

@Component({
  selector: 'app-dimensions-selector',
  templateUrl: './dimensions-selector.component.html',
  styleUrls: ['./dimensions-selector.component.scss']
})
export class DimensionsSelectorComponent {
  @Input() public form: FormGroup;
  @Input() public control: FormControl;
  @Input() public controlName: string = 'dimensions'
  @Input() public appearance: MatFormFieldAppearance = 'outline';
  @Input() public max: number;
  @Input() public labelAnimation: boolean = false;

  public readonly categories$: Observable<DatasetDimensionsGroupComponentObjects> = this._store.select(selectDataSetDimensionsGroupComponentObjects);
  public readonly sources$: Observable<DatasetDimensionsGroupComponentObjects> = this._store.select(selectDimensionSourceGroups);
  public readonly dimensions$: Observable<DimensionComponentObjects> = this._store.select(selectDimensionComponentObjects);

  constructor(
    private _store: Store<AppState>
  ) {}
}
